import { Component } from '@angular/core'

@Component({
  selector: 'app-filter-loader',
  template: ` <div class="spinner">
    <div class="columns is-multiline">
      <div class="column is-3">
        <div class="spinner--label mb-2"></div>
        <input type="text" class="input is-fullwidth" />
      </div>
      <div class="column is-3">
        <div class="spinner--label mb-2"></div>
        <input type="text" class="input is-fullwidth" />
      </div>
      <div class="column is-3">
        <div class="spinner--label mb-2"></div>
        <input type="text" class="input is-fullwidth" />
      </div>
      <div class="column is-3">
        <div class="spinner--label mb-2"></div>
        <input type="text" class="input is-fullwidth" />
      </div>
      <div class="column is-3">
        <div class="spinner--label mb-2"></div>
        <input type="text" class="input is-fullwidth" />
      </div>
      <div class="column is-3">
        <div class="spinner--label mb-2"></div>
        <input type="text" class="input is-fullwidth" />
      </div>
      <div class="column is-3">
        <div class="spinner--label mb-2"></div>
        <input type="text" class="input is-fullwidth" />
      </div>
      <div class="column is-3">
        <div class="spinner--label mb-2"></div>
        <input type="text" class="input is-fullwidth" />
      </div>
      <div class="column is-3">
        <div class="spinner--label mb-2"></div>
        <input type="text" class="input is-fullwidth" />
      </div>
      <div class="column is-3">
        <div class="spinner--label mb-2"></div>
        <input type="text" class="input is-fullwidth" />
      </div>
    </div>
  </div>`
})
export class FilterLoaderComponent {}
